import React from "react";
import AppContainer from "./appcontainer";

const AppRouter = () => {
  return <AppContainer />;
};

export default AppRouter;